import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '服务项目',
    links: [
      { name: '美发造型', path: '/services/hair' },
      { name: '美妆体验', path: '/services/makeup' },
      { name: '护肤管理', path: '/services/skincare' },
      { name: '美甲艺术', path: '/services/nails' },
      { name: '优惠套餐', path: '/services/packages' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { name: '品牌故事', path: '/about' },
      { name: '美丽资讯', path: '/articles' },
      { name: '联系我们', path: '/about#contact' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-heading text-primary-500 font-bold">
                沙龙室
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
              专为在校女大学生打造的专属美发、美妆与美容体验空间。平价时尚，让美丽触手可及。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 女大学生的沙龙室 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-lg" />
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-lg" />
            </a>
            <a href="#" className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" aria-label="小红书">
              <i className="ri-chat-smile-2-line text-lg" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}